import {BasicObject} from '@types';

export const removeUndefinedKeys = (obj: BasicObject) => {
  for (let key in obj) {
    if (obj[key] === undefined) {
      delete obj[key];
    }
  }
};
